import React from 'react';

import SvgContainer from '../SvgContainer';

const Show = () => {
    return (
        <SvgContainer>
            <path d="M8 3C4.52732 3 1.53883 4.89088 0.181012 7.61009C0.0583992 7.85563 0.058399 8.14437 0.181011 8.38991C1.53883 11.1091 4.52732 13 8 13C11.4727 13 14.4612 11.1091 15.819 8.38991C15.9416 8.14437 15.9416 7.85563 15.819 7.61009C14.4612 4.89088 11.4727 3 8 3ZM8 11.3333C5.99273 11.3333 4.36364 9.84 4.36364 8C4.36364 6.16 5.99273 4.66667 8 4.66667C10.0073 4.66667 11.6364 6.16 11.6364 8C11.6364 9.84 10.0073 11.3333 8 11.3333ZM8 6C6.79273 6 5.81818 6.89333 5.81818 8C5.81818 9.10667 6.79273 10 8 10C9.20727 10 10.1818 9.10667 10.1818 8C10.1818 6.89333 9.20727 6 8 6Z" />
        </SvgContainer>
    );
};

export default Show;
